import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Card,
  Form,
  Select,
  Col,
  Divider,
  Spin,
  DatePicker,
  InputNumber,
  Checkbox,
  Tooltip,
} from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import styles from "../../../../../assets/styles/styles";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";

const HoldSavingsAcc = (props) => {
  const { TextArea } = Input;
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const holdCommandId = Form.useWatch("hold", form);

  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [templateDetail, setTemplateDetail] = useState(false);
  const [holdOptions, setHoldOptions] = useState([]);
  const [reasonsOptions, setReasonsOptions] = useState([]);
  const selectedBlockOption = holdOptions?.find(
    (item) => String(item?.value) === String(holdCommandId)
  );

  const filteredReasons = selectedBlockOption?.reasons?.map((item) => ({
    label: item?.name,
    value: item?.id,
  }));
  console.log(selectedBlockOption, "selectedBlockOption");

  useEffect(() => {}, []);

  // const holdOptions = [
  //   {
  //     label: "Savings Account Block",
  //     value: "35",
  //   },
  //   {
  //     label: "Savings Account UnBlock",
  //     value: "45",
  //   },
  //   {
  //     label: "Debit Account Freeze",
  //     value: "36",
  //   },
  //   {
  //     label: "Debit Account UnFreeze",
  //     value: "60",
  //   },
  //   {
  //     label: "Credit Transaction Freeze",
  //     value: "37",
  //   },
  //   {
  //     label: "Credit Transaction UnFreeze",
  //     value: "59",
  //   },
  //   {
  //     label: "Savings Transaction Freeze",
  //     value: "38",
  //   },
  // ];

  // const holdCommandMap = {
  //   35: "block",
  //   45: "unblock",
  //   36: "blockDebit",
  //   60: "unblockDebit",
  //   37: "blockCredit",
  //   59: "unblockCredit",
  //   38: "holdAmount",
  // };

  // const holdSuccessMessage = {
  //   35: "Savings Account was succesfully held",
  //   45: "Savings Account was succesfully unheld",
  //   36: "Debit Savings Account was succesfully blocked",
  //   60: "Debit Savings Account was succesfully unblocked",
  //   37: "Credit Savings Account was succesfully blocked",
  //   59: "Credit Savings Account was succesfully unblocked",
  //   38: "Transaction Amount was held",
  // };

  const getTemplate = () => {
    const params = {
      template: true,
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCurrentOfficer = [];
        let holdTypeOptions = [];

        setTemplateDetail(objDetail);

        objDetail?.fieldOfficerOptions?.forEach((element) => {
          tempCurrentOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });
        // setHoldOptions(() => {
        //   console.log(objDetail?.holdTypeOptions);
        //   return objDetail?.holdTypeOptions?.map((element) => ({
        //     value: element.id,
        //     label: element.name,
        //   }));
        // });

        setIsLoading(false);
      }
    });
  };
  const getSavingsHoldOptions = () => {
    const params = {
      template: true,
    };
    const url = `${apiConfig.savingsAccounts}/hold-options-with-reasons`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;

        setHoldOptions(() => {
          console.log(objDetail?.holdTypeReasonMapping);
          return objDetail?.holdTypeReasonMapping.map((element) => ({
            value: element.id,
            label: element.name,
            actionType: element.actionType,
            reasons: element.reasons,
          }));
        });

        setIsLoading(false);
      }
    });
  };

  const onChangeProduct = (productParam) => {
    form.resetFields(["reasonForBlock"]);
    const url = `${apiConfig.Codes}/${productParam}/codevalues`;

    let body = {
      session,
    };
    setIsLoading(true);
    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].developerMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempReasons = [];
        objList?.forEach((element) => {
          tempReasons.push({
            label: element.name,
            value: element.id,
          });
        });
        setReasonsOptions(tempReasons);

        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/detail-savings-account", { state: state });
  }
  const onSubmit = (formValues) => {
    if (holdCommandId === "38") {
      formValues.transactionDate = formValues.transactionDate
        ? BOM.DateTime(formValues.transactionDate, "only-date")
        : formValues.transactionDate;
    }

    formValues.reasonForBlock = filteredReasons.find(
      (item) => item.value === formValues.reasonForBlock
    ).label;

    delete formValues.hold;

    // const command = holdCommandMap[holdCommandId];
    const command = selectedBlockOption?.actionType;
    let url = `${apiConfig.savingsAccounts}/${state.id}`;
    if (command === "holdAmount") {
      url += "/transactions";
      formValues.transactionAmount = String(formValues.transactionAmount);
      formValues.transactionDate = BOM.DateTime(formValues.transactionDate, "only-date");
    }

    const params = {
      command,
    };

    const body = {
      ...formValues,

      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };
    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, `${selectedBlockOption?.label} Successful`);
          navigate("/detail-savings-account", {
            state: { ...state, statusValue: state?.statusValue.toLowerCase() },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-savings-account", { state: { ...state } });
          setIsLoading(false);
        },
      }
    );
  };

  useEffect(() => {
    getTemplate();
    getSavingsHoldOptions();
  }, []);

  console.log(selectedBlockOption, "reasons");
  console.log(form.getFieldsError(), "reasons");
  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent pageTitle={labelConfig.hold} pageItems={staticConfig.holdBreadcrumbItems} />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.hold}
                  name="hold"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld("Hold"),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                    }
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.hold, "select")}
                    options={holdOptions}
                    showSearch
                    onChange={onChangeProduct}
                  />
                </Form.Item>
              </Col>
              {selectedBlockOption?.label?.toLowerCase() === "savings transaction freeze" && (
                <>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.transactionAmount}
                      name="transactionAmount"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("Transaction Amount"),
                        },
                      ]}
                    >
                      <InputNumber
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.transactionAmount,
                          "select"
                        )}
                        style={styles.ofInputFieldNumber}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.transactionDate}
                      name="transactionDate"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("Transaction Date"),
                        },
                      ]}
                    >
                      <DatePicker
                        disabledDate={BOM.DisabledAfterCurrentDate}
                        style={{ width: "100%", height: 35 }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12} style={{ padding: "0px 8px" }}>
                    <Form.Item label={"lien"} name="lien">
                      <Select
                        placeholder={BOM.handlePlaceholderMsg("lien", "select")}
                        options={staticConfig.yesOrNoData}
                        showSearch
                      />
                    </Form.Item>
                  </Col>
                </>
              )}
              {holdCommandId && (
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.reasons}
                    name="reasonForBlock"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld("Reasons"),
                      },
                    ]}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                      }
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.reasons, "select")}
                      options={filteredReasons}
                      // labelInValue
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={24} style={{ padding: "0px 8px", top: 26 }}>
                <Form.Item name="lien" valuePropName="checked" initialValue={false}></Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default HoldSavingsAcc;
